import { useContext } from 'react';

// auth provider
import AuthContext from 'contexts/JWTContext';

// ==============================|| AUTH HOOK ||============================== //

const useAuth = () => {
    const context = useContext(AuthContext);

    if (!context) throw new Error('Context must be use inside provider');

    return context;
};

export default useAuth;
